import React, { useEffect, useState } from "react";
import DetailSheet from "../session/generate/DetailSheet";
import { Button } from "../ui/button";
import { parseLocalDate, resolveFirstDay, toIsoDate, weekdaysFor } from "../../utils/programmeSchedule";
import { TrainingCalendar, StartOptions } from "./WhenPicker";

/**
 * Resuming a paused programme starts it again from week 1 (#58); this sheet
 * picks the day it starts (#125). `onResume(firstDay)` gets "YYYY-MM-DD".
 */
const ResumeProgrammeSheet = ({ programme, onOpenChange, onResume }) => {
  const [today, setToday] = useState(() => parseLocalDate(new Date()));
  const [start, setStart] = useState({ mode: null });
  // Fresh for each programme opened.
  useEffect(() => {
    if (!programme) return;
    setToday(parseLocalDate(new Date()));
    setStart({ mode: null });
  }, [programme]);

  const perWeek = Number(programme?.days_per_week) || 1;
  const days = programme ? weekdaysFor(programme) : null;
  const firstDay = resolveFirstDay(start, today, days);

  return (
    <DetailSheet
      open={!!programme}
      onOpenChange={onOpenChange}
      title={programme ? `Resume ${programme.title}` : "Resume"}
      description="It starts again from week 1. Pick the day it starts."
      showDescription
      footer={
        <Button
          type="button"
          className="h-12 w-full text-base font-bold"
          onClick={() => onResume(toIsoDate(firstDay))}
        >
          Resume
        </Button>
      }
    >
      {programme && (
        <>
          <TrainingCalendar days={days} perWeek={perWeek} firstDay={firstDay} today={today} />
          <StartOptions
            choice={start}
            onChange={setStart}
            firstDay={firstDay}
            today={today}
            days={days}
            perWeek={perWeek}
          />
        </>
      )}
    </DetailSheet>
  );
};

export default ResumeProgrammeSheet;
